import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['mode', 'commonSelect', 'customInput', 'unitField', 'unitDisplayField', 'validationResult'];

  connect() {
    this.updateMode();
  }

  changeMode() {
    this.updateMode();
  }

  selectCommonUnit() {
    this.unitFieldTarget.value = this.commonSelectTarget.value;
  }

  typeCustomUnit() {
    this.unitFieldTarget.value = this.customInputTarget.value;
    this.clearValidation();
  }

  validateUnit() {
    const unit = this.customInputTarget.value.trim();
    if (!unit) {
      this.showValidation('Please enter a unit to validate.', 'gray');
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch('/units/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ unit: unit })
    })
      .then(response => response.json())
      .then(data => {
        if (data.valid) {
          this.showValidation(`Valid unit: ${data.formatted_html}`, 'green', true);
        } else {
          this.showValidation(`Invalid unit: ${data.error}`, 'red');
        }
      })
      .catch(() => {
        this.showValidation('Unable to validate unit.', 'red');
      });
  }

  showValidation(message, color, html = false) {
    const el = this.validationResultTarget;
    if (html) {
      el.innerHTML = message;
    } else {
      el.textContent = message;
    }
    el.className = `mt-2 ml-1 text-sm text-${color}-600`;
    el.classList.remove('hidden');
  }

  clearValidation() {
    this.validationResultTarget.classList.add('hidden');
  }

  updateMode() {
    const mode = this.modeTarget.value;

    if (mode === 'custom') {
      this.commonSelectTarget.closest('.unit-common-container').classList.add('hidden');
      this.customInputTarget.closest('.unit-custom-container').classList.remove('hidden');
      this.unitFieldTarget.value = this.customInputTarget.value;
    } else {
      this.commonSelectTarget.closest('.unit-common-container').classList.remove('hidden');
      this.customInputTarget.closest('.unit-custom-container').classList.add('hidden');
      this.unitFieldTarget.value = this.commonSelectTarget.value;
      this.clearValidation();
    }
  }
}
